import { DateFormats } from "intake_shared/src/types";
import moment from "../../../../utils/app_moment";

export default function formatCommunicationHistoryTimestamp(
    timestamp?: string | Date | null
) {
    return timestamp
        ? moment(timestamp).format(DateFormats.DAY_YEAR_HOUR_MIN_SEC_FORMAT)
        : "";
}
